import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getKnowledgeBaseRootPath } from '../../../routing/utils/internalPaths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ArticleNotFound extends Component {
  constructor(...args) {
    super(...args);
    this.handleRedirect = () => {
      this.props.onRouteChange(getKnowledgeBaseRootPath());
    };
  }
  render() {
    return /*#__PURE__*/_jsxs(ErrorMessage, {
      type: "notFound",
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.insights.articleDetails.articleNotFound"
        })
      }), /*#__PURE__*/_jsx(Link, {
        onClick: this.handleRedirect,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.shared.knowledgeCenter"
        })
      })]
    });
  }
}
ArticleNotFound.propTypes = {
  onRouteChange: PropTypes.func.isRequired
};
export default ArticleNotFound;